import React, { useState } from "react";
import { CircularProgress } from "@material-ui/core";


import "./style.css";
import { postRequest } from "utils/request";
import { i18n } from '../../../translate/i18n';
import { useNotification } from "hooks/notification";

export default function TabConfig({ companyData, handleUpdate }) {
  const [loading, setLoading] = useState(false);
  const {
    addSelectedCompany
  } = useNotification();

  const handleUploadLogo = (file) => {
    setLoading(true);

    const formData = new FormData();
    formData.append("CompanyId", companyData.id);
    formData.append("logo", file.target.files[0]);

    postRequest("/companies/logo", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then(function (response) {
        setLoading(false);
        if(response.success) {
          handleUpdate(4);
          addSelectedCompany({
            value:  response.data.id,
            id: response.data.id,
            label: response.data.nickName,
            logo: response.data.pathLogo,
            trial: response.data.trial,
            trialLimit: response.data.trialValidate,
            usersLimit: response.data.usersLimit,
            dueDay:  response.data.dueDay,
            ticketToShow: response.data.ticketShowData,
          })
        }
      }
    )
  };

  return (
    <div className="list-container">
      <div className="title-helper-container" style={{marginBottom: 10}}>
        <h3>{companyData.nickName}</h3>
      </div>
      {!loading ? (
        <div className="container-area-config">
          <label>{i18n.t('logo')} *</label>
          <input
            type="file"
            className="form-control-file"
            onChange={handleUploadLogo}
          />
          <div className="area-img-company-logo-config">
            <img
              src={companyData.pathLogo}
              className="img-company-logo-config"
              alt="logo empresa"
            />
          </div>
        </div>
      ) : (
        <div className="area-loading">
          <CircularProgress />
        </div>
      )}
      {/* <h4 className="header-title">Sobre</h4> */}

      {/* <div className="button-list mt-3">
        <button
          onclick="myFunction()"
          type="button"
          className="btn btn-outline-success"
        >
          {" "}
          <i className="mdi mdi-checkbox-marked-circle"></i> Salvar
        </button>
      </div> */}
    </div>
  );
}
